import { Button } from "azure-devops-ui/Button";
import {
    FocusZone,
    FocusZoneContext,
    FocusZoneDirection,
    IFocusZoneContext,
} from "azure-devops-ui/FocusZone";
import * as React from "react";

export default class TrapZoneExample extends React.Component {
    private beforeFocusZoneButtonRef = React.createRef<Button>();
    private afterocusZoneButtonRef = React.createRef<Button>();

    public render(): JSX.Element {
        return (
            <div className="flex-column flex-center" style={{ margin: "8px" }}>
                <Button ref={this.beforeFocusZoneButtonRef} text="Outside Focus Zone" />
                <FocusZone
                    circularNavigation={true}
                    direction={FocusZoneDirection.Horizontal}
                    handleTabKey={true}
                >
                    <div className="flex-row flex-center">
                        <FocusZoneContext.Consumer>
                            {(focusContext: IFocusZoneContext) => (
                                <React.Fragment>
                                    <Button
                                        onClick={() =>
                                            this.beforeFocusZoneButtonRef.current &&
                                            this.beforeFocusZoneButtonRef.current.focus()
                                        }
                                        text={"Click me to escape the focus trap zone"}
                                    />
                                    <div
                                        data-focuszone={focusContext.focuszoneId}
                                        tabIndex={-1}
                                        style={{ marginRight: "8px", padding: "4px" }}
                                    >
                                        Element1
                                    </div>
                                    <div
                                        data-focuszone={focusContext.focuszoneId}
                                        tabIndex={-1}
                                        style={{ marginRight: "8px", padding: "4px" }}
                                    >
                                        Element2
                                    </div>
                                    <div
                                        data-focuszone={focusContext.focuszoneId}
                                        tabIndex={-1}
                                        style={{ marginRight: "8px", padding: "4px" }}
                                    >
                                        Element4
                                    </div>
                                    <div
                                        data-focuszone={focusContext.focuszoneId}
                                        tabIndex={-1}
                                        style={{ marginRight: "8px", padding: "4px" }}
                                    >
                                        Element3
                                    </div>
                                    <Button
                                        onClick={() =>
                                            this.afterocusZoneButtonRef.current &&
                                            this.afterocusZoneButtonRef.current.focus()
                                        }
                                        text={"Click me to escape the focus trap zone"}
                                    />
                                </React.Fragment>
                            )}
                        </FocusZoneContext.Consumer>
                    </div>
                </FocusZone>
                <Button ref={this.afterocusZoneButtonRef} text="Outside Focus Zone" />
            </div>
        );
    }
}
